export const getConfigFromMap = (
  itemId?: number,
  configMap?: { [p: string]: string },
  fallbackMap?: { [p: string]: string },
) => {
  let fileType = '-';
  if (configMap && typeof itemId === 'number') {
    if (configMap[itemId]) {
      fileType = configMap[itemId];
    } else if (fallbackMap && fallbackMap[itemId]) {
      fileType = fallbackMap[itemId];
    }
  }
  return fileType;
};
